import React, { useEffect, useState } from 'react';
import { ENV, SITE_URL } from '../../../config/index.js';

const Tutorial = () => {
  const [activeSlide, setActiveSlide] = useState(1);
  const [activePitchSlide, setActivePitchSlide] = useState(1);

  const maxSlides = 5;

  const nextSlide = () => {
    if (activeSlide === maxSlides) {
      setActiveSlide(1);
    } else {
      setActiveSlide(activeSlide + 1);
    }
  };

  // pitch slider
  const maxPitchSlides = 3;

  const nextPitchSlide = () => {
    if (activePitchSlide === maxPitchSlides) {
      setActivePitchSlide(1);
    } else {
      setActivePitchSlide(activePitchSlide + 1);
    }
  };

  return (
    <div className="fuselight-tutorial-container">
      {/* <div className="tutorial-bg">
        <div></div>
        <div></div>
        <div></div>
      </div> */}
      <section className="section-one">
        <h1>
          Using FuseLight<sup>SM</sup> like a pro.
        </h1>
        <div className="tutorial-steps">
          <div className="step-one step-col">
            <div className="step-title">
              <div>
                <p>Ideate</p>
              </div>
            </div>
            <p>
              Try out your own ideas for brand collaborations or let FuseLight
              <sup>SM</sup> surprise you.
            </p>
          </div>
          <div className="dot-line">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="step-two step-col">
            <div className="step-title">
              <div>
                <p>Evaluate</p>
              </div>
            </div>
            <p>
              Discover the most powerful match-ups possible and bring them to
              life.
            </p>
          </div>
          <div className="dot-line">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="step-three step-col">
            <div className="step-title">
              <div>
                <p>Pitch</p>
              </div>
            </div>
            <p>
              Automatically generate your custom presentation and put your
              launchplans into action.
            </p>
          </div>
        </div>
      </section>
      <section className="section-two">
        <div className="flex-row">
          <div className="flex-col">
            <h2>Create your launchplan.</h2>
            <hr />
            <p>Enter the name of the brand/celebrity you want to promote.</p>
            <p>
              Enter the partner you have in mind. If you don’t have one, no
              worries, just click <span>Need ideas</span> and we’ll help you.
            </p>
            <p>
              You may be asked other optional questions based on your responses.
            </p>
          </div>
          <div className="flex-col">
            <div className="mobile-title">
              <h2>Create your launchplan.</h2>
              <hr />
            </div>
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/tutorial/create-launchplan.svg`
                  : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/create-launchplan.svg`
              }
              alt="Create Launchplan"
            />
          </div>
        </div>
        <div className="dot-route-container">
          <img
            src={
              ENV === 'development'
                ? `${SITE_URL}/app/themes/hahn/images/tutorial/path-one.svg`
                : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/path-one.svg`
            }
            alt="Path One"
          />
        </div>
      </section>
      <section className="section-three">
        <div className="flex-row">
          <div className="flex-col">
            <div className="mobile-title">
              <h2>Ideate.</h2>
              <hr />
            </div>
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/tutorial/ideate-v2.webp`
                  : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/ideate-v2.webp`
              }
              alt="Create Launchplan"
            />
          </div>
          <div className="flex-col">
            <h2>Ideate.</h2>
            <hr />
            <p>
              Here is your launchplan. If you entered your own collaboration
              idea previously, you will be presented with expanded options based
              on your idea.
            </p>
            <p>
              If you did not enter an idea, FuseLight<sup>SM</sup> will present
              you with three new options. You can ignite your favorite or ask
              FuseLightSM to adjust any of them and/or imagine some new ones.
            </p>
            <p>
              When you’re ready to see just how powerful your fusion idea could
              be, just hit <strong>ignite</strong>
            </p>
          </div>
        </div>
        <div className="dot-route-container">
          <img
            src={
              ENV === 'development'
                ? `${SITE_URL}/app/themes/hahn/images/tutorial/path-two.svg`
                : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/path-two.svg`
            }
            alt="Path Two"
          />
        </div>
      </section>
      <section className="section-four">
        <div className="flex-row">
          <div className="flex-col">
            <h2>Evaluate.</h2>
            <hr />
            <p style={{ maxWidth: '490px' }}>
              Welcome to your fusion board. This is where you can see the media
              potential of your brand fusion and bring it to life.
            </p>
            <div className={`custom-slider slide-${activeSlide}-active`}>
              <div className="slider-images" onClick={nextSlide}>
                <div className="slide slide-1">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/ignition-thrust.svg`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/ignition-thrust.svg`
                    }
                    alt="Ignition Thrust"
                  />
                </div>
                <div className="slide slide-2">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/fusion-lift.svg`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/fusion-lift.svg`
                    }
                    alt="Fusion Lift"
                  />
                </div>
                <div className="slide slide-3">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/time-series.svg`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/time-series.svg`
                    }
                    alt="Time Series"
                  />
                </div>
                <div className="slide slide-4">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/map.svg`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/map.svg`
                    }
                    alt="Map"
                  />
                </div>
                <div className="slide slide-5">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/social-post.svg`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/social-post.svg`
                    }
                    alt="Social Post"
                  />
                </div>
              </div>
              <div className="slider-content">
                <div className="slider-content-1">
                  <p>
                    This is the score or power-upon-launch of the fusion. It is
                    rooted in data science and shows you how much more media
                    exposure the brand will get as a percentage (or multiplier)
                    of a typical month.
                  </p>
                  <p>
                    Hover or click the <strong>information icons</strong> to see
                    fusions from similar-sized brands.
                  </p>
                </div>
                <div className="slider-content-2">
                  <p>
                    The top item is the number of mentions the brand being
                    promoted usually gets. The{' '}
                    <span style={{ color: '#00edff' }}>fusion lift</span> is the
                    expected rise in mentions, reach and frequency which gives
                    you a probable view of just how powerful this partnership
                    would be directly out of the gates.
                  </p>
                </div>
                <div className="slider-content-3">
                  <p>
                    Here you can see the historical public interest for each
                    brand singularly or together. This can give you a sense of
                    trajectory or timing in popularity which can help when
                    comparing partners.
                  </p>
                </div>
                <div className="slider-content-4">
                  <p>
                    Here you can view the public interest for both brands by
                    geography. This can give you deeper insight into where your
                    brand fusion matters most.
                  </p>
                </div>
                <div className="slider-content-5">
                  <p>
                    Start visualizing how your brand fusion could come to life
                    with three sample social posts. You can click to see them
                    individually and zoom in or save them. When you’re ready to
                    share the fusion, you can choose the one you want as the
                    cover image.
                  </p>
                </div>
              </div>
              <button className="slider-dots" onClick={nextSlide}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <div className="dot-route-container">
          <img
            src={
              ENV === 'development'
                ? `${SITE_URL}/app/themes/hahn/images/tutorial/path-three.svg`
                : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/path-three.svg`
            }
            alt="Path Three"
          />
        </div>
      </section>
      <section className="section-five">
        <div className="flex-row">
          <div className="flex-col">
            <h2>Pitch.</h2>
            <hr />
            <p>
              Back in the launchplan or directly from the fusion board, you can
              create a fully editable pitch deck in a single click. Just hit
              <span style={{ color: '#ff8b00' }}> Create pitch</span>, choose
              the fusions that you want to feature and hit Submit. In a matter
              of seconds, your presentation will be ready to view so you can
              start putting your launchplans into action.
              <span className="mobile-only">*</span>
            </p>
            <p className="mobile-only">
              <sup>*</sup>Only on desktop version.
            </p>
          </div>
          <div className="flex-col">
            <div className={`custom-slider slide-${activePitchSlide}-active`}>
              <div className="slider-images" onClick={nextPitchSlide}>
                <div className="slide slide-1">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/pitch-1.webp`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/pitch-1.webp`
                    }
                    alt="Pitch Deck"
                  />
                </div>
                <div className="slide slide-2">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/pitch-2.webp`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/pitch-2.webp`
                    }
                    alt="Create Launchplan"
                  />
                </div>
                <div className="slide slide-3">
                  <img
                    src={
                      ENV === 'development'
                        ? `${SITE_URL}/app/themes/hahn/images/tutorial/pitch-3.webp`
                        : `${SITE_URL}/wp-content/themes/hahn/images/tutorial/pitch-3.webp`
                    }
                    alt="Create Launchplan"
                  />
                </div>
              </div>
              <button className="slider-dots" onClick={nextPitchSlide}>
                <span></span>
                <span></span>
                <span></span>
              </button>
              <a
                href="https://docs.google.com/presentation/d/1f91XIyzF3SIeH6UeFxpoa7YxhZmYkpr7UVzMU7jazsc/edit?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="view-pitch btn btn--secondary-outline"
              >
                View pitch
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tutorial;
